import HorizontalRule from '../HorizontalRule';
import React, { Component, Fragment } from 'react';
import ReactHTMLParser from 'react-html-parser';
import ButtonGroup from '../ButtonGroup';
import './style.scss';
class PageHeader extends Component {
  constructor(){
    super()
    this.state = {}
  }

  render(){
    const { data } = this.props
    return (
      <Fragment>
        <header className="page_header page_hero">
          <div className="content">
            <h1 className="title">
              {ReactHTMLParser(data.lxl_page_header_title)}
              <HorizontalRule data={{'lxl_separator_variant': 'hero'}} />
            </h1>
            {data.lxl_page_header_copy && <div className="copy">{ReactHTMLParser(data.lxl_page_header_copy)}</div>}

            {data.lxl_button_group && <ButtonGroup data={data.lxl_button_group}/>}
          </div>
          <div>{data.lxl_page_header_background_image && <img src={data.lxl_page_header_background_image} alt="" />}</div>
        </header>
      </Fragment>
    )
  }
}

export default PageHeader
